/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as DemoTanstackQueryRouteImport } from './routes/demo/tanstack-query'
import { Route as DemoTableRouteImport } from './routes/demo/table'
import { Route as DemoDisallowedRouteImport } from './routes/demo/disallowed'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppSecretMarkerRouteImport } from './routes/_app/secret-marker'
import { Route as AppPoliciesRouteImport } from './routes/_app/policies'
import { Route as AppGroupsRouteImport } from './routes/_app/groups'
import { Route as AppCompanyRouteImport } from './routes/_app/company'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppRolesIndexRouteImport } from './routes/_app/roles/index'
import { Route as AppResolveConflictsIndexRouteImport } from './routes/_app/resolve-conflicts/index'
import { Route as AppPermissionsIndexRouteImport } from './routes/_app/permissions/index'
import { Route as AppLlmApiKeysIndexRouteImport } from './routes/_app/llm-api-keys/index'
import { Route as AppIncidentsIndexRouteImport } from './routes/_app/incidents/index'
import { Route as AppGatewayKeysIndexRouteImport } from './routes/_app/gateway-keys/index'
import { Route as AppEntitiesIndexRouteImport } from './routes/_app/entities/index'
import { Route as AppEdgeDeviceStatisticsIndexRouteImport } from './routes/_app/edge-device-statistics/index'
import { Route as AppDepartmentsIndexRouteImport } from './routes/_app/departments/index'
import { Route as AppCredentialsIndexRouteImport } from './routes/_app/credentials/index'
import { Route as AppUsersIdRouteImport } from './routes/_app/users_/$id'
import { Route as AppPoliciesIdRouteImport } from './routes/_app/policies_/$id'
import { Route as AppGroupsIdRouteImport } from './routes/_app/groups_/$id'
import { Route as AppGatewayKeysCreateRouteImport } from './routes/_app/gateway-keys/create'
import { Route as AppEdgeDeviceStatisticsDepIdIndexRouteImport } from './routes/_app/edge-device-statistics/$depId/index'
import { Route as AppRolesIdPermissionsRouteImport } from './routes/_app/roles_/$id/permissions'
import { Route as AppEdgeDeviceStatisticsDepIdUserIdRouteImport } from './routes/_app/edge-device-statistics/$depId/$userId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const DemoTanstackQueryRoute = DemoTanstackQueryRouteImport.update({
  id: '/demo/tanstack-query',
  path: '/demo/tanstack-query',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTableRoute = DemoTableRouteImport.update({
  id: '/demo/table',
  path: '/demo/table',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoDisallowedRoute = DemoDisallowedRouteImport.update({
  id: '/demo/disallowed',
  path: '/demo/disallowed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSecretMarkerRoute = AppSecretMarkerRouteImport.update({
  id: '/secret-marker',
  path: '/secret-marker',
  getParentRoute: () => AppRoute,
} as any)
const AppPoliciesRoute = AppPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsRoute = AppGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AppRoute,
} as any)
const AppCompanyRoute = AppCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppRolesIndexRoute = AppRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AppRoute,
} as any)
const AppResolveConflictsIndexRoute =
  AppResolveConflictsIndexRouteImport.update({
    id: '/resolve-conflicts/',
    path: '/resolve-conflicts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPermissionsIndexRoute = AppPermissionsIndexRouteImport.update({
  id: '/permissions/',
  path: '/permissions/',
  getParentRoute: () => AppRoute,
} as any)
const AppLlmApiKeysIndexRoute = AppLlmApiKeysIndexRouteImport.update({
  id: '/llm-api-keys/',
  path: '/llm-api-keys/',
  getParentRoute: () => AppRoute,
} as any)
const AppIncidentsIndexRoute = AppIncidentsIndexRouteImport.update({
  id: '/incidents/',
  path: '/incidents/',
  getParentRoute: () => AppRoute,
} as any)
const AppGatewayKeysIndexRoute = AppGatewayKeysIndexRouteImport.update({
  id: '/gateway-keys/',
  path: '/gateway-keys/',
  getParentRoute: () => AppRoute,
} as any)
const AppEntitiesIndexRoute = AppEntitiesIndexRouteImport.update({
  id: '/entities/',
  path: '/entities/',
  getParentRoute: () => AppRoute,
} as any)
const AppEdgeDeviceStatisticsIndexRoute =
  AppEdgeDeviceStatisticsIndexRouteImport.update({
    id: '/edge-device-statistics/',
    path: '/edge-device-statistics/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsIndexRoute = AppDepartmentsIndexRouteImport.update({
  id: '/departments/',
  path: '/departments/',
  getParentRoute: () => AppRoute,
} as any)
const AppCredentialsIndexRoute = AppCredentialsIndexRouteImport.update({
  id: '/credentials/',
  path: '/credentials/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIdRoute = AppUsersIdRouteImport.update({
  id: '/users_/$id',
  path: '/users/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPoliciesIdRoute = AppPoliciesIdRouteImport.update({
  id: '/policies_/$id',
  path: '/policies/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsIdRoute = AppGroupsIdRouteImport.update({
  id: '/groups_/$id',
  path: '/groups/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppGatewayKeysCreateRoute = AppGatewayKeysCreateRouteImport.update({
  id: '/gateway-keys/create',
  path: '/gateway-keys/create',
  getParentRoute: () => AppRoute,
} as any)
const AppEdgeDeviceStatisticsDepIdIndexRoute =
  AppEdgeDeviceStatisticsDepIdIndexRouteImport.update({
    id: '/edge-device-statistics/$depId/',
    path: '/edge-device-statistics/$depId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppRolesIdPermissionsRoute = AppRolesIdPermissionsRouteImport.update({
  id: '/roles_/$id/permissions',
  path: '/roles/$id/permissions',
  getParentRoute: () => AppRoute,
} as any)
const AppEdgeDeviceStatisticsDepIdUserIdRoute =
  AppEdgeDeviceStatisticsDepIdUserIdRouteImport.update({
    id: '/edge-device-statistics/$depId/$userId',
    path: '/edge-device-statistics/$depId/$userId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/analytics': typeof AppAnalyticsRoute
  '/company': typeof AppCompanyRoute
  '/groups': typeof AppGroupsRoute
  '/policies': typeof AppPoliciesRoute
  '/secret-marker': typeof AppSecretMarkerRoute
  '/users': typeof AppUsersRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/demo/disallowed': typeof DemoDisallowedRoute
  '/demo/table': typeof DemoTableRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
  '/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/gateway-keys/create': typeof AppGatewayKeysCreateRoute
  '/groups/$id': typeof AppGroupsIdRoute
  '/policies/$id': typeof AppPoliciesIdRoute
  '/users/$id': typeof AppUsersIdRoute
  '/credentials': typeof AppCredentialsIndexRoute
  '/departments': typeof AppDepartmentsIndexRoute
  '/edge-device-statistics': typeof AppEdgeDeviceStatisticsIndexRoute
  '/entities': typeof AppEntitiesIndexRoute
  '/gateway-keys': typeof AppGatewayKeysIndexRoute
  '/incidents': typeof AppIncidentsIndexRoute
  '/llm-api-keys': typeof AppLlmApiKeysIndexRoute
  '/permissions': typeof AppPermissionsIndexRoute
  '/resolve-conflicts': typeof AppResolveConflictsIndexRoute
  '/roles': typeof AppRolesIndexRoute
  '/edge-device-statistics/$depId/$userId': typeof AppEdgeDeviceStatisticsDepIdUserIdRoute
  '/roles/$id/permissions': typeof AppRolesIdPermissionsRoute
  '/edge-device-statistics/$depId': typeof AppEdgeDeviceStatisticsDepIdIndexRoute
}
export interface FileRoutesByTo {
  '/reset-password': typeof ResetPasswordRoute
  '/analytics': typeof AppAnalyticsRoute
  '/company': typeof AppCompanyRoute
  '/groups': typeof AppGroupsRoute
  '/policies': typeof AppPoliciesRoute
  '/secret-marker': typeof AppSecretMarkerRoute
  '/users': typeof AppUsersRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/demo/disallowed': typeof DemoDisallowedRoute
  '/demo/table': typeof DemoTableRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
  '/': typeof AppIndexRoute
  '/auth': typeof AuthIndexRoute
  '/gateway-keys/create': typeof AppGatewayKeysCreateRoute
  '/groups/$id': typeof AppGroupsIdRoute
  '/policies/$id': typeof AppPoliciesIdRoute
  '/users/$id': typeof AppUsersIdRoute
  '/credentials': typeof AppCredentialsIndexRoute
  '/departments': typeof AppDepartmentsIndexRoute
  '/edge-device-statistics': typeof AppEdgeDeviceStatisticsIndexRoute
  '/entities': typeof AppEntitiesIndexRoute
  '/gateway-keys': typeof AppGatewayKeysIndexRoute
  '/incidents': typeof AppIncidentsIndexRoute
  '/llm-api-keys': typeof AppLlmApiKeysIndexRoute
  '/permissions': typeof AppPermissionsIndexRoute
  '/resolve-conflicts': typeof AppResolveConflictsIndexRoute
  '/roles': typeof AppRolesIndexRoute
  '/edge-device-statistics/$depId/$userId': typeof AppEdgeDeviceStatisticsDepIdUserIdRoute
  '/roles/$id/permissions': typeof AppRolesIdPermissionsRoute
  '/edge-device-statistics/$depId': typeof AppEdgeDeviceStatisticsDepIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/company': typeof AppCompanyRoute
  '/_app/groups': typeof AppGroupsRoute
  '/_app/policies': typeof AppPoliciesRoute
  '/_app/secret-marker': typeof AppSecretMarkerRoute
  '/_app/users': typeof AppUsersRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/demo/disallowed': typeof DemoDisallowedRoute
  '/demo/table': typeof DemoTableRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
  '/_app/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/_app/gateway-keys/create': typeof AppGatewayKeysCreateRoute
  '/_app/groups_/$id': typeof AppGroupsIdRoute
  '/_app/policies_/$id': typeof AppPoliciesIdRoute
  '/_app/users_/$id': typeof AppUsersIdRoute
  '/_app/credentials/': typeof AppCredentialsIndexRoute
  '/_app/departments/': typeof AppDepartmentsIndexRoute
  '/_app/edge-device-statistics/': typeof AppEdgeDeviceStatisticsIndexRoute
  '/_app/entities/': typeof AppEntitiesIndexRoute
  '/_app/gateway-keys/': typeof AppGatewayKeysIndexRoute
  '/_app/incidents/': typeof AppIncidentsIndexRoute
  '/_app/llm-api-keys/': typeof AppLlmApiKeysIndexRoute
  '/_app/permissions/': typeof AppPermissionsIndexRoute
  '/_app/resolve-conflicts/': typeof AppResolveConflictsIndexRoute
  '/_app/roles/': typeof AppRolesIndexRoute
  '/_app/edge-device-statistics/$depId/$userId': typeof AppEdgeDeviceStatisticsDepIdUserIdRoute
  '/_app/roles_/$id/permissions': typeof AppRolesIdPermissionsRoute
  '/_app/edge-device-statistics/$depId/': typeof AppEdgeDeviceStatisticsDepIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/reset-password'
    | '/analytics'
    | '/company'
    | '/groups'
    | '/policies'
    | '/secret-marker'
    | '/users'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/demo/disallowed'
    | '/demo/table'
    | '/demo/tanstack-query'
    | '/'
    | '/auth/'
    | '/gateway-keys/create'
    | '/groups/$id'
    | '/policies/$id'
    | '/users/$id'
    | '/credentials'
    | '/departments'
    | '/edge-device-statistics'
    | '/entities'
    | '/gateway-keys'
    | '/incidents'
    | '/llm-api-keys'
    | '/permissions'
    | '/resolve-conflicts'
    | '/roles'
    | '/edge-device-statistics/$depId/$userId'
    | '/roles/$id/permissions'
    | '/edge-device-statistics/$depId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/reset-password'
    | '/analytics'
    | '/company'
    | '/groups'
    | '/policies'
    | '/secret-marker'
    | '/users'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/demo/disallowed'
    | '/demo/table'
    | '/demo/tanstack-query'
    | '/'
    | '/auth'
    | '/gateway-keys/create'
    | '/groups/$id'
    | '/policies/$id'
    | '/users/$id'
    | '/credentials'
    | '/departments'
    | '/edge-device-statistics'
    | '/entities'
    | '/gateway-keys'
    | '/incidents'
    | '/llm-api-keys'
    | '/permissions'
    | '/resolve-conflicts'
    | '/roles'
    | '/edge-device-statistics/$depId/$userId'
    | '/roles/$id/permissions'
    | '/edge-device-statistics/$depId'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/reset-password'
    | '/_app/analytics'
    | '/_app/company'
    | '/_app/groups'
    | '/_app/policies'
    | '/_app/secret-marker'
    | '/_app/users'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/demo/disallowed'
    | '/demo/table'
    | '/demo/tanstack-query'
    | '/_app/'
    | '/auth/'
    | '/_app/gateway-keys/create'
    | '/_app/groups_/$id'
    | '/_app/policies_/$id'
    | '/_app/users_/$id'
    | '/_app/credentials/'
    | '/_app/departments/'
    | '/_app/edge-device-statistics/'
    | '/_app/entities/'
    | '/_app/gateway-keys/'
    | '/_app/incidents/'
    | '/_app/llm-api-keys/'
    | '/_app/permissions/'
    | '/_app/resolve-conflicts/'
    | '/_app/roles/'
    | '/_app/edge-device-statistics/$depId/$userId'
    | '/_app/roles_/$id/permissions'
    | '/_app/edge-device-statistics/$depId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  DemoDisallowedRoute: typeof DemoDisallowedRoute
  DemoTableRoute: typeof DemoTableRoute
  DemoTanstackQueryRoute: typeof DemoTanstackQueryRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/demo/tanstack-query': {
      id: '/demo/tanstack-query'
      path: '/demo/tanstack-query'
      fullPath: '/demo/tanstack-query'
      preLoaderRoute: typeof DemoTanstackQueryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/table': {
      id: '/demo/table'
      path: '/demo/table'
      fullPath: '/demo/table'
      preLoaderRoute: typeof DemoTableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/disallowed': {
      id: '/demo/disallowed'
      path: '/demo/disallowed'
      fullPath: '/demo/disallowed'
      preLoaderRoute: typeof DemoDisallowedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/secret-marker': {
      id: '/_app/secret-marker'
      path: '/secret-marker'
      fullPath: '/secret-marker'
      preLoaderRoute: typeof AppSecretMarkerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/policies': {
      id: '/_app/policies'
      path: '/policies'
      fullPath: '/policies'
      preLoaderRoute: typeof AppPoliciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups': {
      id: '/_app/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AppGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/company': {
      id: '/_app/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof AppCompanyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roles/': {
      id: '/_app/roles/'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AppRolesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/resolve-conflicts/': {
      id: '/_app/resolve-conflicts/'
      path: '/resolve-conflicts'
      fullPath: '/resolve-conflicts'
      preLoaderRoute: typeof AppResolveConflictsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/permissions/': {
      id: '/_app/permissions/'
      path: '/permissions'
      fullPath: '/permissions'
      preLoaderRoute: typeof AppPermissionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/llm-api-keys/': {
      id: '/_app/llm-api-keys/'
      path: '/llm-api-keys'
      fullPath: '/llm-api-keys'
      preLoaderRoute: typeof AppLlmApiKeysIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/incidents/': {
      id: '/_app/incidents/'
      path: '/incidents'
      fullPath: '/incidents'
      preLoaderRoute: typeof AppIncidentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gateway-keys/': {
      id: '/_app/gateway-keys/'
      path: '/gateway-keys'
      fullPath: '/gateway-keys'
      preLoaderRoute: typeof AppGatewayKeysIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/entities/': {
      id: '/_app/entities/'
      path: '/entities'
      fullPath: '/entities'
      preLoaderRoute: typeof AppEntitiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/edge-device-statistics/': {
      id: '/_app/edge-device-statistics/'
      path: '/edge-device-statistics'
      fullPath: '/edge-device-statistics'
      preLoaderRoute: typeof AppEdgeDeviceStatisticsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/': {
      id: '/_app/departments/'
      path: '/departments'
      fullPath: '/departments'
      preLoaderRoute: typeof AppDepartmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/credentials/': {
      id: '/_app/credentials/'
      path: '/credentials'
      fullPath: '/credentials'
      preLoaderRoute: typeof AppCredentialsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users_/$id': {
      id: '/_app/users_/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AppUsersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/policies_/$id': {
      id: '/_app/policies_/$id'
      path: '/policies/$id'
      fullPath: '/policies/$id'
      preLoaderRoute: typeof AppPoliciesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups_/$id': {
      id: '/_app/groups_/$id'
      path: '/groups/$id'
      fullPath: '/groups/$id'
      preLoaderRoute: typeof AppGroupsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gateway-keys/create': {
      id: '/_app/gateway-keys/create'
      path: '/gateway-keys/create'
      fullPath: '/gateway-keys/create'
      preLoaderRoute: typeof AppGatewayKeysCreateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/edge-device-statistics/$depId/': {
      id: '/_app/edge-device-statistics/$depId/'
      path: '/edge-device-statistics/$depId'
      fullPath: '/edge-device-statistics/$depId'
      preLoaderRoute: typeof AppEdgeDeviceStatisticsDepIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roles_/$id/permissions': {
      id: '/_app/roles_/$id/permissions'
      path: '/roles/$id/permissions'
      fullPath: '/roles/$id/permissions'
      preLoaderRoute: typeof AppRolesIdPermissionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/edge-device-statistics/$depId/$userId': {
      id: '/_app/edge-device-statistics/$depId/$userId'
      path: '/edge-device-statistics/$depId/$userId'
      fullPath: '/edge-device-statistics/$depId/$userId'
      preLoaderRoute: typeof AppEdgeDeviceStatisticsDepIdUserIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppCompanyRoute: typeof AppCompanyRoute
  AppGroupsRoute: typeof AppGroupsRoute
  AppPoliciesRoute: typeof AppPoliciesRoute
  AppSecretMarkerRoute: typeof AppSecretMarkerRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppGatewayKeysCreateRoute: typeof AppGatewayKeysCreateRoute
  AppGroupsIdRoute: typeof AppGroupsIdRoute
  AppPoliciesIdRoute: typeof AppPoliciesIdRoute
  AppUsersIdRoute: typeof AppUsersIdRoute
  AppCredentialsIndexRoute: typeof AppCredentialsIndexRoute
  AppDepartmentsIndexRoute: typeof AppDepartmentsIndexRoute
  AppEdgeDeviceStatisticsIndexRoute: typeof AppEdgeDeviceStatisticsIndexRoute
  AppEntitiesIndexRoute: typeof AppEntitiesIndexRoute
  AppGatewayKeysIndexRoute: typeof AppGatewayKeysIndexRoute
  AppIncidentsIndexRoute: typeof AppIncidentsIndexRoute
  AppLlmApiKeysIndexRoute: typeof AppLlmApiKeysIndexRoute
  AppPermissionsIndexRoute: typeof AppPermissionsIndexRoute
  AppResolveConflictsIndexRoute: typeof AppResolveConflictsIndexRoute
  AppRolesIndexRoute: typeof AppRolesIndexRoute
  AppEdgeDeviceStatisticsDepIdUserIdRoute: typeof AppEdgeDeviceStatisticsDepIdUserIdRoute
  AppRolesIdPermissionsRoute: typeof AppRolesIdPermissionsRoute
  AppEdgeDeviceStatisticsDepIdIndexRoute: typeof AppEdgeDeviceStatisticsDepIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppCompanyRoute: AppCompanyRoute,
  AppGroupsRoute: AppGroupsRoute,
  AppPoliciesRoute: AppPoliciesRoute,
  AppSecretMarkerRoute: AppSecretMarkerRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppGatewayKeysCreateRoute: AppGatewayKeysCreateRoute,
  AppGroupsIdRoute: AppGroupsIdRoute,
  AppPoliciesIdRoute: AppPoliciesIdRoute,
  AppUsersIdRoute: AppUsersIdRoute,
  AppCredentialsIndexRoute: AppCredentialsIndexRoute,
  AppDepartmentsIndexRoute: AppDepartmentsIndexRoute,
  AppEdgeDeviceStatisticsIndexRoute: AppEdgeDeviceStatisticsIndexRoute,
  AppEntitiesIndexRoute: AppEntitiesIndexRoute,
  AppGatewayKeysIndexRoute: AppGatewayKeysIndexRoute,
  AppIncidentsIndexRoute: AppIncidentsIndexRoute,
  AppLlmApiKeysIndexRoute: AppLlmApiKeysIndexRoute,
  AppPermissionsIndexRoute: AppPermissionsIndexRoute,
  AppResolveConflictsIndexRoute: AppResolveConflictsIndexRoute,
  AppRolesIndexRoute: AppRolesIndexRoute,
  AppEdgeDeviceStatisticsDepIdUserIdRoute:
    AppEdgeDeviceStatisticsDepIdUserIdRoute,
  AppRolesIdPermissionsRoute: AppRolesIdPermissionsRoute,
  AppEdgeDeviceStatisticsDepIdIndexRoute:
    AppEdgeDeviceStatisticsDepIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  DemoDisallowedRoute: DemoDisallowedRoute,
  DemoTableRoute: DemoTableRoute,
  DemoTanstackQueryRoute: DemoTanstackQueryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
